export const RECEIVE_WIKIDATA_LABELS = 'RECEIVE_WIKIDATA_LABELS';
